import React, { useEffect, useState } from "react";
import { InventoryList } from "./InvetoryList";
import Theme from "../jsonObjects/theme.json";

export function InventoryTable({
  Title,
  Data,
  handleRowSelection,
  selectedRow,
  search,
  refresh,
}) {
  const handleRowClick = (id) => {
    handleRowSelection(id);
  };

  const [isLandscape, setIsLandscape] = useState(
    window.matchMedia("(orientation: landscape)").matches,
  );

  useEffect(() => {
    console.log(isLandscape);
  }, [isLandscape]);

  function landScapeView() {
    return (
      <>
        <h1 style={{ borderBottom: "1px solid var(--block)", width: "100%" }}>
          {Title}
        </h1>
        <table>
          <thead>
            <tr>
              <th style={{ width: "auto" }}>Namn</th>
              <th>Startdatum</th>
              <th>Status</th>
              <th>Värde</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(Data).map(
              ([monthKey, monthData]) =>
                (monthKey.toLowerCase().includes(search.toLowerCase()) ||
                  monthData.date.includes(search)) && (
                  <React.Fragment key={monthData.id}>
                    <tr
                      className="row hoverButton"
                      onClick={() => handleRowClick(monthData.id)}
                    >
                      <td>{monthKey}</td>
                      <td>{monthData.date}</td>
                      <td className="status">
                        <span
                          style={{
                            display: "inline-block",
                            backgroundColor:
                              monthData.active == 1 ? "#c9ffcc" : "#ffc9c9",
                            color: Theme.colors.foreground,
                            padding: "0 5%",
                            borderRadius: "5px",
                          }}
                        >
                          {monthData.active == 1 ? "Öppen" : "Stängd"}
                        </span>
                      </td>
                      <td>{monthData.value}</td>
                    </tr>
                    {selectedRow === monthData.id && (
                      <tr className="expandableRow">
                        <td colSpan="4">
                          <InventoryList
                            inventoryID={monthData.id}
                            active={monthData.active == 1}
                            amount={monthData.value}
                            name={monthKey}
                            year={Title}
                            refresh={refresh}
                          />
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ),
            )}
          </tbody>
        </table>
      </>
    );
  }

  function portraitView() {
    return <h1>{Title}</h1>;
  }

  return <>{isLandscape ? landScapeView() : landScapeView()}</>;
}
